export const getIpAddress = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json'); // Or another IP API
      if (!response.ok) {
        throw new Error('Failed to fetch IP address');
      }
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP address:', error);
      return ''; // Return an empty string if the IP cannot be fetched
    }
  };
  